import { API_BASE_URL } from '../../env';
import { ApiReturnType } from '../../interfaces/api/api';
import {
  CreateAppointmentOptions,
  LegacyAppointment,
  LegacyNote,
  LegacyReminder,
  LegacyTask,
} from '../../interfaces/api/Collaborative';
import { arrayToQueryString, toQueryParamsString } from '../../utils/ApiUtils';
import { Order } from '../../interfaces/Table';

export default {
  getAppointmentTypes: (): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/collaborative/appointments-types`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  addAppointment: (options: CreateAppointmentOptions): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/collaborative/appointments`,
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(options),
    method: 'POST',
  }),
  getAppointments: (
    ids: number[],
    page: number,
    limit: number,
    orderBy: keyof LegacyAppointment,
    order: Order
  ): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/collaborative/appointments${
      arrayToQueryString('ids', ids) + toQueryParamsString({ page, limit, orderBy, order }, false)
    }`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  getAppointment: (id: number): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/collaborative/appointments/${id}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  removeAppointment: (id: LegacyAppointment['id']): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/collaborative/appointments/${id}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'DELETE',
  }),
  getNotes: (ids: number[], page: number, limit: number, orderBy: keyof LegacyNote, order: Order): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/collaborative/notes${
      arrayToQueryString('ids', ids) + toQueryParamsString({ page, limit, orderBy, order }, false)
    }`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  getNote: (id: number): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/collaborative/notes/${id}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  removeNote: (id: LegacyNote['id']): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/collaborative/notes/${id}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'DELETE',
  }),
  getTasks: (ids: number[], page: number, limit: number, orderBy: keyof LegacyTask, order: Order): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/collaborative/tasks${
      arrayToQueryString('ids', ids) + toQueryParamsString({ page, limit, orderBy, order }, false)
    }`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  getTask: (id: number): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/collaborative/tasks/${id}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  removeTask: (id: LegacyTask['id']): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/collaborative/tasks/${id}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'DELETE',
  }),
  getReminders: (
    ids: number[],
    page: number,
    limit: number,
    orderBy: keyof LegacyReminder,
    order: Order
  ): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/collaborative/reminders${
      arrayToQueryString('ids', ids) + toQueryParamsString({ page, limit, orderBy, order }, false)
    }`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  getReminder: (id: number): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/collaborative/reminders/${id}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'GET',
  }),
  removeReminder: (id: LegacyReminder['id']): ApiReturnType => ({
    endpoint: `${API_BASE_URL}/v2/collaborative/reminders/${id}`,
    headers: { 'Content-Type': 'application/json' },
    method: 'DELETE',
  }),
};
